import { Grid } from "@mui/material";
import { LocationModel } from "object-models/location-model";
import CategoryInfo from "./CategoryInfo";

/**
 * Displays detailed category information based on the provided location details.
 *
 * @component
 * @param {locationDetails} props - The properties for the CategoryInfoDetails component.
 * @returns {JSX.Element} The rendered CategoryInfoDetails component.
 */
const CategoryInfoDetails = ({
  locationDetails,
}: {
  locationDetails: LocationModel | null;
}): JSX.Element => {
  if (locationDetails === null) {
    return <div>No data available.</div>;
  }
  const categories = [
    {
      category: "Category 1",
      label: "Purchased Goods & Services",
      value: locationDetails.purchasedGoodsAndServices,
    },
    {
      category: "Category 2",
      label: "Capital Goods",
      value: locationDetails.capitalGoods,
    },
    {
      category: "Category 3",
      label: "Fuel- and Energy-Related Activities",
      value: locationDetails.fuelandEnergyRelatedActivities,
    },
    {
      category: "Category 4",
      label: "Upstream Transportation & Distribution",
      value: locationDetails.upstreamTransportationAndDistribution,
    },
    {
      category: "Category 5",
      label: "Waste Generated in Operations",
      value: locationDetails.wasteGeneratedinOperations,
    },
    {
      category: "Category 6",
      label: "Business Travel",
      value: locationDetails.businessTravel,
    },
    {
      category: "Category 7",
      label: "Employee Commuting",
      value: locationDetails.employeeCommuting,
    },
    {
      category: "Category 8",
      label: "Upstream Leased Assets",
      value: locationDetails.upstreamLeasedAssets,
    },
    {
      category: "Category 9",
      label: "Downstream Transportation & Distribution",
      value: locationDetails.downstreamTransportationAndDistribution,
    },
    {
      category: "Category 10",
      label: "Processing of Sold Products",
      value: locationDetails.processingofSoldProducts,
    },
    {
      category: "Category 11",
      label: "Use of Sold Products",
      value: locationDetails.useofSoldProducts,
    },
    {
      category: "Category 12",
      label: "End-of-Life Treatment of Sold Products",
      value: locationDetails.endofLifeTreatmentofSoldProducts,
    },
    {
      category: "Category 13",
      label: "Downstream Leased Assets",
      value: locationDetails.downstreamLeasedAssets,
    },
    {
      category: "Category 14",
      label: "Franchises",
      value: locationDetails.franchises,
    },
    {
      category: "Category 15",
      label: "Investments",
      value: locationDetails.investments,
    },
    {
      category: "Category 16",
      label: "Other Upstream",
      value: locationDetails.otherUpstream,
    },
    {
      category: "Category 17",
      label: "Other Downstream",
      value: locationDetails.otherDownstream,
    },
  ];
  return (
    <Grid container spacing={2} sx={{ mt: 0 }}>
      <Grid item xs={12}>
        <Grid container spacing={2} sx={{ mt: 0, mb: 5 }}>
          {categories.map((categoryData, index) => (
            <CategoryInfo
              key={categoryData.category}
              category={categoryData.category}
              value={Number(categoryData.value).toLocaleString("en-US")}
              label={categoryData.label}
            />
          ))}
        </Grid>
        <Grid item xs={10} sx={{ mb: 1 }}></Grid>
      </Grid>
    </Grid>
  );
};

export default CategoryInfoDetails;
